import AddCardWalletModal from './AddCardWalletModal';

export default AddCardWalletModal;
